/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import { AutoMailActionTypes } from '../../action/auto_action/AutoMailActions'
import { AutoActionMailState } from '../state/AutoActionMailState'

class AutoActionMailsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List([])
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case AutoMailActionTypes.fetchAll:
        const mails = payload.mails.map(mail => {
          return new AutoActionMailState(mail)
        })
        return List(mails)
      default:
        return state
    }
  }
}

export default new AutoActionMailsStore()
